import React from 'react';
import PublicLayout from '../components/landing/PublicLayout';
import HeroSection from '../components/landing/HeroSection';
import TrustBadgesSection from '../components/landing/TrustBadgesSection';
import ServicesSection from '../components/landing/ServicesSection';
import GallerySection from '../components/landing/GallerySection';
import BrandsSection from '../components/landing/BrandsSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import PriceMatchSection from '../components/landing/PriceMatchSection';
import PrePurchaseSection from '../components/landing/PrePurchaseSection';
import ContactSection from '../components/landing/ContactSection';
import Footer from '../components/landing/Footer';

/**
 * LandingPage - Customer-facing homepage
 * Showcases automotive services and expertise
 */
const LandingPage: React.FC = () => {
  return (
    <PublicLayout>
      <HeroSection />
      <TrustBadgesSection />
      <ServicesSection />
      <GallerySection />
      <BrandsSection />
      <TestimonialsSection />
      <PriceMatchSection />
      <PrePurchaseSection />
      <ContactSection />
      <Footer />
    </PublicLayout>
  );
};

export default LandingPage;
